import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminTable from 'common/AdminTable';
import { getRequest, deleteRequest } from 'apis/ApiInstence';
import { FaTrash, FaEdit } from 'react-icons/fa';

const BACKEND = process.env.REACT_APP_BACKEND;

const List = () => {
  const [galleryData, setGalleryData] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchGallery = async () => {
    try {
      const response = await getRequest('galleries');
      const data = Array.isArray(response?.data)
        ? response.data
        : Array.isArray(response?.data?.data)
          ? response.data.data
          : [];
      setGalleryData(data);
    } catch (error) {
      console.error('Error fetching gallery:', error);
      setGalleryData([]);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this image?')) {
      try {
        await deleteRequest(`galleries/${id}`);
        fetchGallery();
      } catch (error) {
        console.error('Error deleting image:', error);
        alert('Failed to delete image.');
      }
    }
  };

  const tableHeaders = [
    { Header: 'ID', accessor: 'id' },
    { Header: 'Name', accessor: 'name' },
    {
      Header: 'Image',
      accessor: 'image',
      Cell: ({ row }) => {
        const imageName = row.original.image;
        const imageUrl = imageName
          ? `${BACKEND}gallery/${imageName}`
          : '/Images/default.jpg';

        return (
          <img
            src={imageUrl}
            alt={row.original.name}
            width={100}
            height={100}
            style={{ objectFit: 'cover', borderRadius: 8 }}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = '/Images/default.jpg';
            }}
          />
        );
      },
    },
    {
      Header: 'Action',
      accessor: 'action',
      Cell: ({ row }) => (
        <>
          <button
            className="btn btn-sm mx-1 text-white"
            style={{ backgroundColor: '#ffc107' }}
            onClick={() => navigate(`/gallery/update/${row.original.id}`)}
          >
            <FaEdit />
          </button>
          <button
            className="btn btn-sm mx-1 text-white"
            style={{ backgroundColor: '#dc3545' }}
            onClick={() => handleDelete(row.original.id)}
          >
            <FaTrash />
          </button>
        </>
      ),
    },
  ];

  useEffect(() => {
    fetchGallery();
  }, []);

  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4">
        <h4 className="text-white font-weight-bold">Benner List</h4>
      </div>

      {loading ? (
        <div className="text-center mt-4 text-muted">Loading...</div>
      ) : galleryData.length > 0 ? (
        <AdminTable tableHeaders={tableHeaders} tableData={galleryData} />
      ) : (
        <div className="text-center mt-4 text-muted">No gallery images found.</div>
      )}
    </div>
  );
};

export default List;
